import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconEducationSvg } from "./IconEducationSvg.mjs";
const IconEducation = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconEducationSvg, ...svgProps }) });
export {
  IconEducation
};
